import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useLang } from "@/i18n/LanguageContext";


const HOVER_BLUE = "#0057FF";

export default function BottomBar() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [btnHover, setBtnHover] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;
    setSubmitting(true);
    const { error } = await supabase.from("waitlist").insert({ email: trimmed } as any);
    if (!error || error.code === "23505") {
      setDone(true);
      supabase.functions
        .invoke("send-transactional-email", {
          body: { type: "waitlist-confirmation", data: { to: trimmed } },
        })
        .catch(() => {});
    }
    setSubmitting(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: "var(--lp-glass-bg)",
        backdropFilter: "blur(20px) saturate(160%)",
        WebkitBackdropFilter: "blur(20px) saturate(160%)",
        borderTop: "0.5px solid var(--lp-border)",

        padding: "0.9rem 2.5rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: "'IBM Plex Mono', monospace",
      }}
    >
      <span
        className="bottom-bar-side"
        style={{
          fontSize: "0.7rem",
          textTransform: "uppercase",
          letterSpacing: "0.14em",
          color: "var(--lp-muted)",
        }}
      >
        {t('bottomBar.tagline')}
      </span>

      <form
        onSubmit={handleSubmit}
        className="bottom-bar-form"
        style={{ display: "flex", maxWidth: 420, flex: 1, margin: "0 2rem" }}
      >
        <input
          type="email"
          aria-label={t('bottomBar.placeholder')}
          placeholder={t('bottomBar.placeholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={done}
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "0.8rem",
            fontWeight: 300,
            background: "transparent",
            border: "0.5px solid var(--lp-border2)",
            borderRight: "none",
            borderRadius: 0,
            padding: "0.85rem 1.25rem",
            color: "var(--lp-ink)",
            outline: "none",
            flex: 1,
            minWidth: 0,
          }}
        />
        <button
          type="submit"
          disabled={done || submitting}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: "0.68rem",
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            background: btnHover && !done ? HOVER_BLUE : "var(--lp-ink)",
            color: "var(--lp-bg)",
            border: "none",
            borderRadius: 0,
            padding: "0.85rem 1.5rem",
            cursor: done ? "default" : "pointer",
            whiteSpace: "nowrap",
            transition: "background 0.2s ease",
          }}
        >
          {done ? t('bottomBar.done') : t('bottomBar.submit')}
        </button>
      </form>

      <span
        className="bottom-bar-side"
        style={{
          fontSize: "0.68rem",
          textTransform: "uppercase",
          letterSpacing: "0.14em",
          color: "var(--lp-muted)",
        }}
      >
        {t('bottomBar.launch')}
      </span>
    </div>
  );
}
